import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InvoiceListPage } from '@/features/billing'

export const Route = createFileRoute('/_authenticated/billing/invoices')({
  component: () => (
    <RequirePermission permission='invoices.read'>
      <InvoiceListPage />
    </RequirePermission>
  ),
})
